/* ============================================================
   ANIVA — Cart drawer custom (remplace celui de Dawn)
   Section 'aniva-cart-drawer' rendue dans theme.liquid.

   Deux chemins de mise à jour :
   · CHANGEMENT DE QUANTITÉ → un seul appel /cart/change.js, et on
     patche le DOM avec le panier renvoyé par Shopify (prix déjà
     remisés : selling plans + remises automatiques comprises).
     Aucun re-rendu de section, aucun flash, scroll conservé.
   · CHANGEMENT STRUCTUREL (ajout, retrait, bascule abo/unique)
     → Section Rendering API, car le balisage lui-même change.
     Même là, on ne remplace que l'intérieur du panneau.

   API globale : window.AnivaCart.{add, open, close, refresh, change}
   ============================================================ */
(function () {
  'use strict';
  if (window.AnivaCart) return;

  /* Ce qu'on demande à l'API de rendu doit être l'identifiant de l'INSTANCE
     de section, pas le nom du fichier. Avec le nom du fichier, Shopify rend
     bien la section — mais avec les réglages PAR DÉFAUT du schéma, en
     ignorant ceux enregistrés dans footer-group.json. Concrètement : la
     remise affichée retombait à 20 % alors qu'elle est réglée à 25, et le
     bloc cross-sell disparaissait à chaque mise à jour du panier, parce
     qu'un bloc n'existe que dans l'instance.
     L'identifiant réel est porté par le conteneur que Shopify enveloppe
     autour de la section : shopify-section-sections--123__aniva-cart-drawer.
     On le lit dans le DOM, donc rien à maintenir en double. */
  var SECTION_FALLBACK = 'aniva-cart-drawer';

  function sectionId() {
    var r = root();
    var w = r && r.closest && r.closest('[id^="shopify-section-"]');
    return w ? w.id.replace('shopify-section-', '') : SECTION_FALLBACK;
  }

  function root() { return document.getElementById('AnivaCartDrawer'); }

  function setLoading(on) {
    var r = root(); if (r) r.classList.toggle('is-loading', !!on);
  }

  /* ---------- formatage monétaire aligné sur shop.money_format ---------- */
  function formatMoney(cents, fmt) {
    if (typeof cents !== 'number' || isNaN(cents)) return '';
    fmt = fmt || '{{amount_with_comma_separator}} €';
    function num(dec, thousand, decimal) {
      var parts = (Math.abs(cents) / 100).toFixed(dec).split('.');
      parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, thousand);
      return (cents < 0 ? '-' : '') + (parts.length > 1 ? parts.join(decimal) : parts[0]);
    }
    return fmt.replace(/\{\{\s*(\w+)\s*\}\}/g, function (_, name) {
      switch (name) {
        case 'amount': return num(2, ',', '.');
        case 'amount_no_decimals': return num(0, ',', '.');
        case 'amount_with_comma_separator': return num(2, '.', ',');
        case 'amount_no_decimals_with_comma_separator': return num(0, '.', ',');
        case 'amount_with_space_separator': return num(2, ' ', ',');
        case 'amount_no_decimals_with_space_separator': return num(0, ' ', ',');
        case 'amount_with_apostrophe_separator': return num(2, "'", '.');
        default: return num(2, '.', ',');
      }
    });
  }

  /* Barre de livraison : tout en inline, aucune dépendance à la cascade.
     Le dégradé est dimensionné sur la largeur TOTALE de la piste, donc la
     couleur d'un point donné ne bouge pas quand la barre grandit. */
  function paintBar(fill, pct) {
    pct = Math.max(1, Math.min(100, Math.round(pct)));
    fill.style.width = pct + '%';
    fill.style.minWidth = '14px';
    fill.style.backgroundColor = '#6E9950';
    fill.style.backgroundImage = 'linear-gradient(90deg,#9BC17C 0%,#6E9950 45%,#2F4A3A 100%)';
    fill.style.backgroundRepeat = 'no-repeat';
    fill.style.backgroundSize = Math.round(10000 / pct) + '% 100%';
  }

  function updateHeaderBubble(count) {
    var icon = document.getElementById('cart-icon-bubble');
    if (!icon) return;
    var bubble = icon.querySelector('.cart-count-bubble');
    if (count > 0) {
      if (!bubble) {
        bubble = document.createElement('div');
        bubble.className = 'cart-count-bubble';
        icon.appendChild(bubble);
      }
      bubble.innerHTML = '<span aria-hidden="true">' + (count < 100 ? count : '99+') + '</span><span class="visually-hidden">' + count + '</span>';
    } else if (bubble) { bubble.remove(); }
  }

  /* ---------- patch local depuis le JSON /cart/change.js ----------
     Renvoie false si la structure a bougé → l'appelant refait un
     rendu de section complet. On ne devine jamais un prix : tout
     vient de l'objet cart de Shopify. */
  function patchCart(cart) {
    var r = root();
    if (!r || !cart || !cart.items) return false;

    var lines = r.querySelectorAll('.an-line-item');
    if (lines.length !== cart.items.length || lines.length === 0) return false;

    var fmt = r.getAttribute('data-an-money-format') || '';
    var threshold = parseInt(r.getAttribute('data-an-threshold') || '0', 10);
    var giftVal = parseInt(r.getAttribute('data-an-gift-val') || '0', 10);
    var offertLab = r.getAttribute('data-an-offert') || 'Offert';
    var hasAbo = false, eco = 0;

    for (var i = 0; i < cart.items.length; i++) {
      var it = cart.items[i], el = lines[i];
      if (it.selling_plan_allocation) hasAbo = true;

      var out = el.querySelector('.an-line-item__qty span');
      if (out) out.textContent = it.quantity;

      var minus = el.querySelector('[data-an-line-dir="-1"]');
      var plus = el.querySelector('[data-an-line-dir="1"]');
      if (minus) {
        minus.setAttribute('data-an-line-qty', Math.max(1, it.quantity - 1));
        minus.disabled = it.quantity <= 1;
      }
      if (plus) plus.setAttribute('data-an-line-qty', it.quantity + 1);

      var qtyHolders = el.querySelectorAll('[data-an-line-current-qty]');
      for (var k = 0; k < qtyHolders.length; k++) qtyHolders[k].setAttribute('data-an-line-current-qty', it.quantity);

      /* Shopify renvoie original_line_price == final_line_price sur une ligne
         d'abonnement : la remise du selling plan n'y apparait pas. Le prix de
         reference est dans selling_plan_allocation.compare_at_price. */
      var refU = 0;
      if (it.selling_plan_allocation && it.selling_plan_allocation.compare_at_price > it.final_price) {
        refU = it.selling_plan_allocation.compare_at_price;
      }
      var estCadeau = it.final_price === 0;
      if (!refU && estCadeau) refU = giftVal;

      var per = el.querySelector('.an-line-item__per');
      if (per) {
        per.innerHTML = (refU > it.final_price ? '<s>' + formatMoney(refU, fmt) + '</s>' : '')
          + (estCadeau ? '' : formatMoney(it.final_price, fmt) + '/pot');
      }

      var refL = refU * it.quantity;
      if (refU > it.final_price) eco += (refU - it.final_price) * it.quantity;

      var tot = el.querySelector('.an-line-item__total');
      if (tot) {
        tot.innerHTML = (refL > it.final_line_price ? '<s>' + formatMoney(refL, fmt) + '</s>' : '')
          + (estCadeau ? offertLab : formatMoney(it.final_line_price, fmt));
      }
    }

    r.setAttribute('data-an-count', cart.item_count);
    var small = r.querySelector('.an-drawer__title small');
    if (small) small.textContent = '(' + cart.item_count + ')';

    var sub = r.querySelector('.an-drawer__subtotal b');
    if (sub) sub.textContent = formatMoney(cart.total_price, fmt);

    var cta = r.querySelector('.an-drawer__cta');
    if (cta) cta.textContent = 'Commander · ' + formatMoney(cart.total_price, fmt);

    var ship = r.querySelector('.an-drawer__ship');
    if (ship && threshold > 0) {
      var remaining = threshold - cart.total_price;
      var pct = Math.min(100, Math.floor(cart.total_price * 100 / threshold));
      var msg = ship.querySelector('p');
      var fill = ship.querySelector('.an-drawer__bar > div');
      var shown = (hasAbo || remaining <= 0) ? 100 : Math.max(1, pct);
      if (hasAbo || remaining <= 0) {
        if (msg) msg.textContent = r.getAttribute('data-an-ship-done') || 'Livraison offerte débloquée !';
      } else if (msg) {
        msg.textContent = 'Plus que ' + formatMoney(remaining, fmt) + ' pour la livraison offerte';
      }
      var bar = ship.querySelector('.an-drawer__bar');
      if (bar) bar.setAttribute('data-an-pct', shown);
      if (fill) paintBar(fill, shown);
    }

    /* la ligne d'economie suit la quantite. Si elle n'existe pas encore dans
       le DOM (panier sans remise au rendu), c'est le rendu de section qui la
       fera apparaitre — un changement de quantite ne cree pas de balise. */
    var ecoBox = r.querySelector('.an-drawer__eco');
    if (ecoBox) {
      var ecoVal = ecoBox.querySelector('b');
      if (eco > 0 && ecoVal) { ecoVal.textContent = '-' + formatMoney(eco, fmt); ecoBox.hidden = false; }
      else { ecoBox.hidden = true; }
    }

    updateHeaderBubble(cart.item_count);
    return true;
  }

  /* ---------- rendu de section (changements structurels) ----------
     On remplace l'intérieur du panneau, pas le drawer : pas de flash,
     pas de rejeu de l'animation d'ouverture, scroll conservé. */
  function refresh() {
    var id = sectionId();
    return fetch(window.location.pathname + '?sections=' + encodeURIComponent(id))
      .then(function (r) { return r.json(); })
      .then(function (json) {
        var html = json[id];
        if (!html) return;
        var tmp = document.createElement('div');
        tmp.innerHTML = html;
        var fresh = tmp.querySelector('#AnivaCartDrawer');
        var cur = root();
        if (!fresh || !cur) return;

        var items = cur.querySelector('.an-drawer__items');
        var scroll = items ? items.scrollTop : 0;
        var freshPanel = fresh.querySelector('.an-drawer__panel');
        var curPanel = cur.querySelector('.an-drawer__panel');

        if (freshPanel && curPanel) {
          curPanel.innerHTML = freshPanel.innerHTML;
          var attrs = ['data-an-count', 'data-an-money-format', 'data-an-threshold', 'data-an-ship-done'];
          for (var i = 0; i < attrs.length; i++) {
            var v = fresh.getAttribute(attrs[i]);
            if (v !== null) cur.setAttribute(attrs[i], v);
          }
        } else {
          var wasOpen = !cur.hidden;
          cur.replaceWith(fresh);
          fresh.hidden = !wasOpen;
        }

        var newItems = (root() || fresh).querySelector('.an-drawer__items');
        if (newItems) newItems.scrollTop = scroll;
        updateHeaderBubble(parseInt((root() || fresh).getAttribute('data-an-count') || '0', 10));
      })
      .then(syncCadeau);
  }

  /* Le cadeau est lie a l'abonnement : present tant qu'une ligne est en abo,
     retire des qu'il n'y en a plus. On lit le panier reel plutot que de
     deviner depuis le DOM, et un verrou empeche la boucle
     add -> refresh -> syncCadeau -> add. */
  function syncCadeau() {
    var r = root();
    if (!r || syncCadeau._busy) return Promise.resolve();
    var gid = parseInt(r.getAttribute('data-an-gift-id') || '0', 10);
    if (!gid) return Promise.resolve();

    function fini() { syncCadeau._busy = false; }

    return fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
      .then(function (x) { return x.json(); })
      .then(function (cart) {
        var abo = false, cadeaux = [];
        for (var i = 0; i < cart.items.length; i++) {
          var it = cart.items[i];
          if (it.selling_plan_allocation) abo = true;
          if (it.variant_id === gid) cadeaux.push(it);
        }

        /* Le cadeau arrive par deux chemins : le CTA de la LP l'ajoute avec la
           propriete « Offert », le tiroir l'ajoute sans. Deux jeux de
           proprietes = deux CLES de ligne = deux lignes, meme variante. D'ou
           le doublon. On garde la premiere ligne a 1 et on met les autres a 0,
           en une seule requete /cart/update.js indexee par cle (les index de
           ligne, eux, se decalent des qu'on en supprime une). */
        if (abo && !cadeaux.length) {
          syncCadeau._busy = true;
          return fetch('/cart/add.js', {
            method: 'POST', headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ items: [{ id: gid, quantity: 1 }] }) })
            .then(refresh).then(fini, fini);
        }

        var updates = {}, besoin = false;
        for (var k = 0; k < cadeaux.length; k++) {
          var vise = (abo && k === 0) ? 1 : 0;
          if (cadeaux[k].quantity !== vise) { updates[cadeaux[k].key] = vise; besoin = true; }
        }
        if (!besoin) return null;

        syncCadeau._busy = true;
        return fetch('/cart/update.js', {
          method: 'POST', headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ updates: updates }) })
          .then(refresh).then(fini, fini);
      })
      .catch(fini);
  }

  function open() {
    var r = root(); if (!r) return;
    r.hidden = false;
    document.body.style.overflow = 'hidden';
    var x = r.querySelector('[data-an-drawer-close]');
    if (x) x.focus({ preventScroll: true });
  }
  function close() {
    var r = root(); if (!r) return;
    r.hidden = true;
    document.body.style.overflow = '';
  }

  /* Message d'erreur NON bloquant. window.alert() sur mobile fige la page
     et masque le panier : le visiteur ne voit plus rien. On affiche le
     message tel que Shopify le renvoie, dans le tiroir, et on ouvre le
     tiroir pour qu'il soit lu. */
  function showError(msg) {
    var r = root();
    if (!r) { console.warn('[AnivaCart] ' + msg); return; }
    var panel = r.querySelector('.an-drawer__panel') || r;
    var box = r.querySelector('[data-an-drawer-error]');
    if (!box) {
      box = document.createElement('div');
      box.setAttribute('data-an-drawer-error', '');
      box.setAttribute('role', 'alert');
      box.style.cssText = 'margin:10px 14px;padding:10px 12px;border-radius:12px;'
        + 'background:#FDECEC;color:#8A1F1F;border:1px solid #F0B4B4;'
        + 'font-size:12.5px;font-weight:700;line-height:1.35';
      var head = panel.querySelector('.an-drawer__head');
      if (head && head.parentNode) head.parentNode.insertBefore(box, head.nextSibling);
      else panel.insertBefore(box, panel.firstChild);
    }
    box.textContent = msg;
    box.hidden = false;
    open();
    clearTimeout(showError._t);
    showError._t = setTimeout(function () { if (box) box.hidden = true; }, 9000);
  }

  function add(items) {
    setLoading(true);
    return fetch(((window.routes && window.routes.cart_add_url) || '/cart/add') + '.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ items: items })
    })
      .then(function (r) {
        if (!r.ok) return r.json().then(function (j) { throw j; });
        return r.json();
      })
      .then(refresh)
      .then(function () { setLoading(false); open(); })
      .catch(function (err) {
        setLoading(false);
        var msg = (err && (err.description || err.message)) || 'Impossible d’ajouter au panier.';
        showError(msg);
      });
  }

  /* ---------- file d'attente : une seule requête panier à la fois ---------- */
  var busy = false, queuedJob = null;

  function send(payload, structural) {
    if (busy) { queuedJob = { p: payload, s: structural }; return Promise.resolve(); }
    busy = true;
    if (structural) setLoading(true);
    return fetch(((window.routes && window.routes.cart_change_url) || '/cart/change') + '.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(payload)
    })
      .then(function (r) {
        if (!r.ok) return r.json().then(function (j) { throw j; });
        return r.json();
      })
      .then(function (cart) {
        if (!structural && patchCart(cart)) return null;
        return refresh();
      })
      .catch(function (e) {
        /* Meme traitement pour les changements de quantite / bascule abo :
           l'erreur Shopify etait avalee, le panier revenait a son etat
           precedent sans un mot. */
        if (e && (e.description || e.message)) showError(e.description || e.message);
        return refresh();
      })
      .then(function () {
        busy = false;
        setLoading(false);
        if (queuedJob) { var q = queuedJob; queuedJob = null; send(q.p, q.s); }
      });
  }

  function change(payload, structural) {
    return send(payload, structural !== false);
  }

  /* ---------- quantité : anti-rebond + retour visuel immédiat ---------- */
  var qtyTimer = null, qtyJob = null;

  function queueQty(line, qty, out) {
    if (out) out.textContent = qty;
    qtyJob = { line: line, quantity: qty };
    clearTimeout(qtyTimer);
    qtyTimer = setTimeout(function () {
      var j = qtyJob; qtyJob = null;
      if (j) send(j, false);
    }, 260);
  }

  window.AnivaCart = { add: add, open: open, close: close, refresh: refresh, change: change };

  document.addEventListener('click', function (e) {
    var icon = e.target.closest('#cart-icon-bubble');
    if (icon) { e.preventDefault(); open(); return; }

    var r = root(); if (!r) return;

    if (e.target.closest('[data-an-drawer-close]') || e.target.closest('[data-an-drawer-bg]')) { close(); return; }

    var t = e.target.closest('[data-an-line-qty],[data-an-line-remove],[data-an-line-mode],[data-an-line-upsell],[data-an-xsell-add]');
    if (!t || !r.contains(t)) return;

    if (t.hasAttribute('data-an-line-qty')) {
      var line = parseInt(t.getAttribute('data-an-line'), 10);
      var wrap = t.closest('.an-line-item__qty');
      var out = wrap ? wrap.querySelector('span') : null;
      var dir = parseInt(t.getAttribute('data-an-line-dir') || '0', 10);
      var shown = out ? parseInt(out.textContent, 10) : NaN;
      var next;
      if (dir && !isNaN(shown)) next = Math.max(1, shown + dir);
      else next = Math.max(1, parseInt(t.getAttribute('data-an-line-qty'), 10) || 1);
      if (next === shown) return;
      if (dir < 0 && shown <= 1) return;
      queueQty(line, next, out);
    } else if (t.hasAttribute('data-an-line-remove')) {
      send({ line: parseInt(t.getAttribute('data-an-line'), 10), quantity: 0 }, true);
    } else if (t.hasAttribute('data-an-line-mode')) {
      var mode = t.getAttribute('data-an-line-mode');
      var planId = t.getAttribute('data-an-line-plan') || '';
      if (mode === 'abo' && !planId) return;
      send({
        line: parseInt(t.getAttribute('data-an-line'), 10),
        quantity: parseInt(t.getAttribute('data-an-line-current-qty'), 10) || 1,
        selling_plan: mode === 'abo' ? parseInt(planId, 10) : null
      }, true);
    } else if (t.hasAttribute('data-an-line-upsell')) {
      var planId2 = t.getAttribute('data-an-line-plan') || '';
      if (!planId2) return;
      send({
        line: parseInt(t.getAttribute('data-an-line'), 10),
        quantity: parseInt(t.getAttribute('data-an-line-current-qty'), 10) || 1,
        selling_plan: parseInt(planId2, 10)
      }, true);
    } else if (t.hasAttribute('data-an-xsell-add')) {
      add([{ id: parseInt(t.getAttribute('data-an-xsell-add'), 10), quantity: 1 }]);
    }
  });

  /* Filet de sécurité : si une modif de quantité est encore en vol au
     moment où l'utilisateur part au checkout, on la laisse passer. */
  document.addEventListener('click', function (e) {
    var cta = e.target.closest('.an-drawer__cta');
    if (!cta) return;
    if (qtyJob) {
      clearTimeout(qtyTimer);
      var j = qtyJob; qtyJob = null;
      e.preventDefault();
      send(j, false).then(function () { window.location.href = cta.getAttribute('href'); });
    }
  }, true);

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') { var r = root(); if (r && !r.hidden) close(); }
  });

  if (window.location.hash === '#panier') {
    window.addEventListener('DOMContentLoaded', open);
  }
})();
